import { render, staticRenderFns } from "./OTableUsersComp.vue?vue&type=template&id=2c8c8e5d&"
import script from "./OTableUsersComp.vue?vue&type=script&lang=js&"
export * from "./OTableUsersComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports